import { defineStore } from "pinia";
import { useScopePointerStore } from "./scopePointerStore";
export function defineScopedStore(id, setup) {
    return (scopeId) => {
        const { scope } = useScopePointerStore();
        return defineStore(`${id}-${scope(scopeId)}`, () => setup(scopeId))();
    };
}
